<template>
  <el-dialog title="MRP运算详情" :visible.sync="visible" width="92%" append-to-body :close-on-click-modal="false" @closed="onClosed">
    <el-descriptions :column="3" border size="small">
      <el-descriptions-item label="批次号">{{ head.mrpRunCode }}</el-descriptions-item>
      <el-descriptions-item label="运算日期">{{ (head.runDate || '').slice(0, 10) }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ head.runStatus === '2' ? '已确认' : (head.runStatus === '1' ? '已运行' : '草稿') }}</el-descriptions-item>
    </el-descriptions>
    <el-table :data="lines" border size="small" style="margin-top:12px" :header-cell-style="headStyle">
      <el-table-column type="index" width="50" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="needDate" label="需求日期" width="110" />
      <el-table-column prop="grossDemandQty" label="毛需求" width="90" align="right" />
      <el-table-column prop="onHandQty" label="现有量" width="90" align="right" />
      <el-table-column prop="supplyQty" label="在途供给" width="90" align="right" />
      <el-table-column prop="netDemandQty" label="净需求" width="90" align="right" />
      <el-table-column prop="suggestType" label="建议" width="80" align="center">
        <template slot-scope="s">{{ suggestLabel(s.row.suggestType) }}</template>
      </el-table-column>
      <el-table-column prop="suggestQty" label="建议数量" width="100" align="right" />
      <el-table-column prop="exceptionCode" label="例外" width="110" align="center">
        <template slot-scope="s">{{ exceptionLabel(s.row.exceptionCode) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="说明" min-width="180" show-overflow-tooltip />
    </el-table>
    <el-table v-if="periods.length" :data="periods" border size="small" style="margin-top:12px" :header-cell-style="headStyle">
      <el-table-column prop="weekStart" label="周起始" width="110" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="grossDemandQty" label="周毛需求" width="100" align="right" />
      <el-table-column prop="netDemandQty" label="周净需求" width="100" align="right" />
      <el-table-column prop="suggestQty" label="周建议" width="100" align="right" />
    </el-table>
    <span slot="footer">
      <el-button v-if="isAuth('production:mrpRun:generatePlanned') && (head.runStatus === '1' || head.runStatus === '2')" type="primary" size="small" @click="$emit('generate-planned', head)">生成计划单</el-button>
      <el-button v-if="isAuth('production:mrpRun:generatePurchase') && (head.runStatus === '1' || head.runStatus === '2')" type="primary" size="small" @click="$emit('generate-purchase', head)">生成采购单</el-button>
      <el-button v-if="isAuth('production:mrpRun:delete') && (head.runStatus === '0' || head.runStatus === '1')" type="primary" size="small" @click="$emit('delete-run', head)">删除</el-button>
      <el-button @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'MrpRunInfo',
  data() {
    return {
      visible: false,
      head: {},
      lines: [],
      periods: [],
      permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    onClosed() {
      this.head = {}
      this.lines = []
      this.periods = []
    },
    suggestLabel(type) {
      if (type === 'make' || type === 'planned') return '自制'
      if (type === 'buy') return '外购'
      if (type === 'subcontract') return '委外'
      if (type === 'none') return '无'
      return type || ''
    },
    exceptionLabel(code) {
      if (code === 'STOCK_COVER') return '库存可满足'
      if (code === 'NO_BOM') return '无BOM'
      if (code === 'NO_SUPPLIER') return '无供应商'
      return code ? code : '—'
    },
    init(row) {
      this.head = row || {}
      this.lines = []
      this.periods = []
      this.visible = true
      if (!row || !row.mrpRunId) return
      request.get('/plan/mrp/lines', { params: { id: row.mrpRunId } }).then(res => { this.lines = res.data || [] }).catch(() => { this.lines = [] })
      request.get('/plan/mrp/periods', { params: { id: row.mrpRunId } }).then(res => { this.periods = res.data || [] }).catch(() => { this.periods = [] })
    },
    close() {
      this.visible = false
    }
  }
}
</script>
